/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
import { MenuItem, Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import styled from "styled-components";

import Colors from "@constants/Colors";

export const StyledDropdown = styled(Select)`
  padding-right: 0px !important;
  .MuiSelect-select {
    color: ${Colors.neutral_gray_500} !important;
  }
  .Mui-disabled {
    cursor: not-allowed !important;
    color: ${Colors.neutral_gray_300} !important;
  }
  .MuiSelect-icon.Mui-disabled {
    filter: opacity(25%) invert(95%) sepia(11%) saturate(654%)
      hue-rotate(187deg) brightness(92%) contrast(88%);
  }
`;

export const StyledFormControl = styled(FormControl)<{
  disabled: boolean;
  error: boolean;
  nodata: string;
}>`
  .MuiFormLabel-root {
    color: ${({ disabled, error }: { disabled: boolean; error: boolean }) =>
      // eslint-disable-next-line no-nested-ternary
      disabled
        ? Colors.neutral_gray_300
        : error
        ? Colors.primaryred
        : Colors.neutralblack} !important;
    font-family: "Ringside Regular-Bold" !important;
    font-weight: 400 !important;
    font-size: 18px !important;
    line-height: 20px !important;
    padding-top: 5px;
  }
  .MuiInputBase-root {
    border-radius: 8px !important;
  }
  .MuiOutlinedInput-notchedOutline {
    border: ${({ error }: { error: boolean }) =>
      error
        ? `2px solid ${Colors.primaryred}`
        : `1px solid ${Colors.neutral_gray_300}`}!important;
    font-size: 19px !important;
  }
  .Mui-error {
    color: ${Colors.primaryred} !important;
  }
  .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border: ${({ nodata }: { nodata: string }) =>
      nodata.length
        ? `2px solid ${Colors.error_500}`
        : `2px solid ${Colors.neutral_gray_300}`} !important;
    color: ${({ nodata }: { nodata: string }) =>
      nodata.length ? Colors.error_500 : Colors.neutral_gray_300} !important;
  }
`;

export const StyledTypography = styled(Typography)<{
  error: boolean | undefined;
  disabled: boolean | undefined;
}>`
  color: ${({ error }: { error: boolean | undefined }) =>
    error ? Colors.primaryred : Colors.neutral_gray_500} !important;
  font-family: "Ringside Regular-Book" !important;
  font-weight: 325 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  -webkit-text-fill-color: ${({
    disabled,
    error,
  }: {
    disabled: boolean | undefined;
    error: boolean | undefined;
  }) =>
    disabled
      ? Colors.neutral_gray_300
      : error
      ? Colors.primaryred
      : Colors.neutral_gray_500} !important;
`;

export const StyledMenuItem = styled(MenuItem)`
  font-family: "Ringside Regular-Book" !important;
  font-weight: 325 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  padding: 8px 16px !important;
`;
